import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the preset item to inform that the viz should display a drag handle
 * @param {PresetItem} Item The item to enhance
 */
export const withDragHandle: PresetHOC<{ showDragHandle?: boolean }> = (
    Item
) => {
    Item.showDragHandle = true;

    return Item;
};
